import React from 'react';

export default function WorkoutWizardNudge({ onContinue }) {
  return (
    <div className="border-b border-iron-info/35 bg-iron-info/10">
      <div className="max-w-app mx-auto flex w-full items-center gap-3 px-5 py-2.5">
        <span className="inline-flex h-2 w-2 shrink-0 rounded-full bg-iron-info" aria-hidden />
        <p className="min-w-0 flex-1 font-mono text-[10px] text-iron-text sm:text-xs">
          Complete o seu perfil para gerar treinos com IA.
        </p>
        <button
          type="button"
          onClick={onContinue}
          className="shrink-0 rounded-lg border border-iron-info/50 px-3 py-1.5 font-mono text-[10px] uppercase tracking-wide text-iron-info hover:bg-iron-info/15"
        >
          Continuar
        </button>
      </div>
    </div>
  );
}
